import { URL_GET_USER_ROLE_GROUPS_API } from 'constants/urls';

/**
 * @function getUserGroupsApi
 * @returns {object}
 * @desc - API URL='/api/userservice/GetUserGroupsApi'
 */
async function getUserGroupsApi() {
	const options = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
	};

	const res = await fetch(URL_GET_USER_ROLE_GROUPS_API, options);

	if (!res.ok) {
		const message = `HTTP error! status message: ${res.statusText}`;
		throw new Error(message);
	} else {
		const { userRoleGroups } = await res.json();
		return userRoleGroups;
	}
}

export default getUserGroupsApi;
